export const CUSTOM_MODEL_STATUS = {
  created: 'created',
  training_in_progress: 'training_in_progress',
  recreating: 'recreating',
  error: 'error',
  active: 'active', // after progress
};

const PROCESSING_ERROR_TYPE = {
  notEnoughDatasetError: 'not_enough_dataset_error',
  notEnoughRelevantDataError: 'not_enough_relevant_data_error',
  assetTypeNotSupportedError: 'asset_type_not_supported_error',
  notEnoughEnglishDatasetError: 'not_enough_english_dataset_error',
  systemError: 'system_error',
};

const PROCESSING_ERROR_TYPE_PROPS = {
  [PROCESSING_ERROR_TYPE.notEnoughDatasetError]: {
    message: 'Not enough dataset examples to train the model',
  },
  [PROCESSING_ERROR_TYPE.notEnoughRelevantDataError]: {
    message: 'Custom model training failed. Not enough training assets were available',
  },
  [PROCESSING_ERROR_TYPE.assetTypeNotSupportedError]: {
    message: 'Custom model training failed. Not enough training assets were available',
  },
  [PROCESSING_ERROR_TYPE.notEnoughEnglishDatasetError]: {
    message: 'Custom model training failed. Not enough training assets were available',
  },
  [PROCESSING_ERROR_TYPE.systemError]: {
    message: 'something went wrong',
  },
};

export const getProcessingErrorTypeMessage = (type) =>
  PROCESSING_ERROR_TYPE_PROPS?.[type]?.message ||
  'We were unable to create a custom model. Please try again later.';

export const getCustomModelTexts = (customModelId, customModels) => {
  const selectedCustomModel = customModels?.find((customModel) => customModel.id === customModelId);

  return {
    customModelTitle: selectedCustomModel?.accountName,
    customModelLabel: selectedCustomModel?.brandVoiceName,
  };
};

export const filterActiveCustomModels = (customModels) => {
  return customModels.filter((customModel) => customModel.status === CUSTOM_MODEL_STATUS.active);
};
